/**
 * Security Headers Configuration
 *
 * This file defines security headers for the Tempii Web application
 * to protect against common web vulnerabilities.
 */

export interface SecurityHeaders {
  [key: string]: string;
}

export const getSecurityHeaders = (): SecurityHeaders => {
  const isProduction = import.meta.env.PROD;

  return {
    // Content Security Policy
    //TODO: move to config
    "Content-Security-Policy": isProduction
      ? "default-src 'self'; script-src 'self' 'unsafe-inline' 'unsafe-eval' https://login.microsoftonline.com; style-src 'self' 'unsafe-inline'; font-src 'self'; img-src 'self' data: https:; connect-src 'self' https://api.tempii.ai https://login.microsoftonline.com; frame-src 'self' https://login.microsoftonline.com;"
      : "default-src 'self'; script-src 'self' 'unsafe-inline' 'unsafe-eval'; style-src 'self' 'unsafe-inline'; font-src 'self'; img-src 'self' data:; connect-src 'self' http://localhost:*; frame-src 'self';",

    // X-Frame-Options: Prevent clickjacking
    "X-Frame-Options": "DENY",

    // X-Content-Type-Options: Prevent MIME type sniffing
    "X-Content-Type-Options": "nosniff",

    // X-XSS-Protection: Enable XSS filtering
    "X-XSS-Protection": "1; mode=block",

    // Referrer Policy: Control referrer information
    "Referrer-Policy": "strict-origin-when-cross-origin",

    // Permissions Policy: Control browser features
    "Permissions-Policy":
      "camera=(), microphone=(), geolocation=(), payment=()",

    // Strict Transport Security (HTTPS only in production)
    ...(isProduction && {
      "Strict-Transport-Security":
        "max-age=31536000; includeSubDomains; preload"
    }),

    // Cache Control for sensitive pages
    "Cache-Control": "no-store, no-cache, must-revalidate, proxy-revalidate",
    Pragma: "no-cache",
    Expires: "0"
  };
};

/**
 * Validate security headers configuration
 */
export const validateSecurityHeaders = (headers: SecurityHeaders): boolean => {
  const requiredHeaders = [
    "Content-Security-Policy",
    "X-Frame-Options",
    "X-Content-Type-Options",
    "X-XSS-Protection",
    "Referrer-Policy",
    "Permissions-Policy"
  ];

  return requiredHeaders.every((header) => headers[header] !== undefined);
};

/**
 * Get CSP nonce for inline scripts (if needed)
 */
export const generateCSPNonce = (): string => {
  return Array.from(crypto.getRandomValues(new Uint8Array(16)))
    .map((b) => b.toString(16).padStart(2, "0"))
    .join("");
};
